import React from "react";
import { Input, Typography } from "antd";
import { InputContainer } from "./styles";

interface TextareaComponentProps {
	title?: string;
	style?: React.CSSProperties;
	isRequired?: boolean;
	value?: string | undefined;
	onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	placeholder?: string;
	error?: boolean;
	isDisabled?: boolean;
	readonly?: boolean;
	rows?: number;
	height?: string | number;
}

const TextareaComponent = ({
	title,
	style,
	isRequired = false,
	value = "",
	onChange,
	placeholder = "",
	isDisabled,
	readonly = false,
	rows = 4,
}: TextareaComponentProps) => {
	return (
		<InputContainer>
			{title &&(
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title}
					{isRequired && <span style={{ color: "red" }}>&nbsp;*</span>}
				</Typography.Title>
			)}
			<Input.TextArea
				rows={rows}
				style={{ 
					cursor: readonly ? "not-allowed" : "auto", 
					...style 
				}}
				value={value}
				onChange={onChange}
				disabled={isDisabled}
				placeholder={placeholder}
				readOnly={readonly}
			/>
		</InputContainer>
	);
};

export default TextareaComponent;
